// extracted by mini-css-extract-plugin
export default {"interactive-object":"interactiveObject_interactive-object__d7z7g","header":"interactiveObject_header__SaLjA","manual-input-row":"interactiveObject_manual-input-row__Y78eK"};